<template>
  <div class="search">
    <addEdit v-if="currView=='addEdit'" @close="currView='index'" @submited="submited" :data="formData" :addEditFlag="addEditFlag"/>
    <Card v-show="currView=='index'">
        <Row @keydown.enter.native="handleSearch">
          <Form ref="searchForm" :model="searchForm" inline :label-width="100" class="search-form">
              <Form-item label="手机号码" prop="telno">
                <Input type="text" v-model="searchForm.telno" placeholder="请输入手机号码" clearable style="width: 200px"/>
              </Form-item>
              <Form-item label="发生日期" prop="fsrq">
                <Input type="text" v-model="searchForm.fsrq" placeholder="请输入发生日期" clearable style="width: 200px"/>
              </Form-item>
              <Form-item label="交易单号" prop="tradeno">
                <Input type="text" v-model="searchForm.tradeno" placeholder="请输入交易单号" clearable style="width: 200px"/>
              </Form-item>
              <Form-item label="IMEI码" prop="imei">
                <Input type="text" v-model="searchForm.imei" placeholder="请输入IMEI码" clearable style="width: 200px"/>
              </Form-item>
              <Form-item style="margin-left:-35px;" class="br">
                <Button @click="handleSearch" type="primary" icon="ios-search">搜索</Button>
                <Button @click="handleReset">重置</Button>
                <Button @click="add" type="warning" icon="md-add">添加</Button>
              </Form-item>
          </Form>
        </Row>
      <!-- <Row class="operation">
        <Button @click="add" type="primary" icon="md-add">添加</Button>
        <Button @click="delAll" icon="md-trash">批量删除</Button>
        <Button @click="getDataList" icon="md-refresh">刷新</Button>
        <Button type="dashed" @click="openTip=!openTip">{{openTip ? "关闭提示" : "开启提示"}}</Button>
      </Row>
      <Row v-show="openTip">
        <Alert show-icon>
          已选择
          <span class="select-count">{{selectCount}}</span> 项
          <a class="select-clear" @click="clearSelectAll">清空</a>
        </Alert>
      </Row> -->
      <Row>
        <Table
          :loading="loading"
          border
          :columns="columns"
          :data="data"
          ref="table"
          sortable="custom"
          @on-sort-change="changeSort"
          @on-selection-change="changeSelect"
        ></Table>
      </Row>
      <Row type="flex" justify="end" class="page">
        <Page
          :current="searchForm.pageNumber"
          :total="total"
          :page-size="searchForm.pageSize"
          @on-change="changePage"
          @on-page-size-change="changePageSize"
          :page-size-opts="[10,20,50]"
          size="small"
          show-total
          show-elevator
          show-sizer
        ></Page>
      </Row>
    </Card>
  </div>
</template>

<script>
// 根据你的实际请求api.js位置路径修改
import { getDeviceBuyList, deleteDeviceBuy } from "@/api/busi/data-manage/device-buy.js";
// 根据你的实际添加编辑组件位置路径修改
import addEdit from "./deviceBuyAddEdit.vue";
export default {
  name: "deviceBuy",
  components: {
    addEdit
  },
  data() {
    return {
      openSearch: true, // 显示搜索
      openTip: true, // 显示提示
      formData: {},
      addEditFlag:"1",
      currView: "index",
      loading: true, // 表单加载状态
      drop: false,
      dropDownContent: "展开",
      dropDownIcon: "ios-arrow-down",
      searchForm: { // 搜索框初始化对象
        pageNumber: 1, // 当前页数
        pageSize: 10, // 页面大小
        sort: "fsrq", // 默认排序字段
        order: "desc", // 默认排序方式
      },
      selectList: [], // 多选数据
      selectCount: 0, // 多选计数
      columns: [
      // 表头
      // {
      //   type: "selection",
      //   width: 60,
      //   align: "center"
      // },
      {
        type: "index",
        width: 60,
        align: "center"
      },
      {
        title: "手机号码",
        key: "telno",
        minWidth: 130,
        sortable: false,
        align: "center"
      },
      {
        title: "发生日期",
        key: "fsrq",
        minWidth: 170,
        sortable: false,
        align: "center"
      },
      {
        title: "IMEI码",
        key: "imei",
        minWidth: 180,
        sortable: false,
        align: "center"
      },
      {
        title: "序列号",
        key: "ensn",
        minWidth: 180,
        sortable: false,
        align: "center"
      },
      {
        title: "购买类型",
        key: "buytype",
        minWidth: 100,
        sortable: false,
       align: "center"
      },
      {
        title: "IMEI码2",
        key: "imei2",
        minWidth: 180,
        sortable: false,
        align: "center"
      },
      {
        title: "序列号2",
        key: "ensn2",
        minWidth: 180,
        sortable: false,
        align: "center"
      },
      {
        title: "交易单号",
        key: "tradeno",
        minWidth: 120,
        sortable: false,
        align: "center"
      },
      {
        title: "操作",
        key: "action",
        align: "center",
        fixed: "right",
        width: 180,
        render: (h, params) => {
          return h("div", [
            h(
              "Button",
              {
                props: {
                  type: "primary",
                  size: "small",
                  icon: "ios-create-outline"
                },
                style: {
                  marginRight: "5px"
                },
                on: {
                  click: () => {
                    this.edit(params.row);
                  }
                }
              },
              "编辑"
            ),
            h(
              "Button",
              {
                props: {
                  type: "error",
                  size: "small",
                  icon: "md-trash"
                },
                on: {
                  click: () => {
                    this.remove(params.row);
                  }
                }
              },
              "删除"
            )
          ]);
        }
      }
    ],
      data: [], // 表单数据
      pageNumber: 1, // 当前页数
      pageSize: 10, // 页面大小
      total: 0 // 表单数据总数
    };
  },
  methods: {
    init() {
      this.getDataList();
    },
    submited() {
      this.currView = "index";
      this.getDataList();
    },
    changePage(v) {
      this.searchForm.pageNumber = v;
      this.getDataList();
      this.clearSelectAll();
    },
    changePageSize(v) {
      this.searchForm.pageSize = v;
      this.getDataList();
    },
    handleSearch() {
      this.searchForm.pageNumber = 1;
      this.searchForm.pageSize = 10;
      this.getDataList();
    },
    handleReset() {
      this.$refs.searchForm.resetFields();
      this.searchForm.pageNumber = 1;
      this.searchForm.pageSize = 10;
      // 重新加载数据
      this.getDataList();
    },
    changeSort(e) {
      this.searchForm.sort = e.key;
      this.searchForm.order = e.order;
      if (e.order === "normal") {
        this.searchForm.order = "";
      }
      this.getDataList();
    },
    dropDown() {
      if (this.drop) {
        this.dropDownContent = "展开";
        this.dropDownIcon = "ios-arrow-down";
      } else {
        this.dropDownContent = "收起";
        this.dropDownIcon = "ios-arrow-up";
      }
      this.drop = !this.drop;
    },
    clearSelectAll() {
      this.$refs.table.selectAll(false);
    },
    changeSelect(e) {
      this.selectList = e;
      this.selectCount = e.length;
    },
    getDataList() {
      this.loading = true;
        getDeviceBuyList(this.searchForm).then(res => {
          this.loading = false;
          if (res.success) {
            //this.data = res.result.content;
            //this.total = res.result.totalElements;
            this.data = res.result.records;
            this.total = res.result.total;
          }
        });
    },
    add() {
      this.currView = "addEdit";
      this.addEditFlag = "1";
    },
    edit(v) {
      // 转换null为""
      for (let attr in v) {
        if (v[attr] == null) {
          v[attr] = "";
        }
      }
      let str = JSON.stringify(v);
      let data = JSON.parse(str);
      this.formData = data;
      this.currView = "addEdit";
      this.addEditFlag = "2";
    },
    remove(v) {
      this.$Modal.confirm({
        title: "确认删除",
        // 记得确认修改此处
        content: "您确认要删除 " + v.telno + " ?",
        loading: true,
        onOk: () => {
          // 删除
            deleteDeviceBuy({ids: v.id}).then(res => {
              this.$Modal.remove();
              if (res.success) {
                this.$Message.success("操作成功");
                this.getDataList();
              }
            });
        }
      });
    },
    delAll() {
      if (this.selectCount <= 0) {
        this.$Message.warning("您还未选择要删除的数据");
        return;
      }
      this.$Modal.confirm({
        title: "确认删除",
        content: "您确认要删除所选的 " + this.selectCount + " 条数据?",
        loading: true,
        onOk: () => {
          let ids = "";
          this.selectList.forEach(function(e) {
            ids += e.id + ",";
          });
          ids = ids.substring(0, ids.length - 1);
          // 批量删除
            deleteDeviceBuy({ids: ids}).then(res => {
              this.$Modal.remove();
              if (res.success) {
                this.$Message.success("操作成功");
                this.clearSelectAll();
                this.getDataList();
              }
            });
        }
      });
    }
  },
  mounted() {
    this.init();
  }
};
</script>
<style lang="less">
// 建议引入通用样式 具体路径自行修改 可删除下面样式代码
// @import "../../../styles/table-common.less";
.search {
    .operation {
        margin-bottom: 2vh;
    }
    .select-count {
        font-weight: 600;
        color: #40a9ff;
    }
    .select-clear {
        margin-left: 10px;
    }
    .page {
        margin-top: 2vh;
    }
    .drop-down {
        margin-left: 5px;
    }
}
</style>